import React from "react";
import img1 from "../../../../Assets/Images/01-img-01.png";
import img2 from "../../../../Assets/Images/img-platform-function-02@3x.png";
import img3 from "../../../../Assets/Images/img-platform-function-03@3x.png";
import img4 from "../../../../Assets/Images/img-platform-function-04@3x.png";
import "./styles.scss";

function membermain() {
    return (
      <div className="instruction">
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              background: item.backgroundColor,
            }}
            className="instruction-container"
          >
            <div
              style={{ flexDirection: index % 2 !== 0 ? "row-reverse" : "row" }}
              className="instruction-container-item"
            >
              <div className="content">
                <div className="titleFm">{item.title}</div>
                <ul className="detailFm">
                  <li>{item.detail1}</li>
                  <li>{item.detail2}</li>
                  <li>{item.detail3}</li>
                  <li>{item.detail4}</li>
                </ul>
              </div>
              
              <div
                style={{
                  justifyContent: index % 2 !== 0 ? "flex-start" : "flex-end",
                }}
                className="img"
              >
                <img src={item.img} alt="" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  
  export default membermain;
  
  const data = [
    {
      title: `自分のお問い合わせ内訳を一目で確認`,
      detail1: "·  サービス別に分散されたお問い合わせのご返答を一目で確認 ",
      detail2: "·  追加のお問い合わせもCSBYEで一目で解決",
      detail3: "·  以前のお問い合わせ内訳も確認可能",
      detail4: "·  お問い合わせ受付及び進行状態確認可能",
      img: img1,
      backgroundColor: "#63aeff",
    },

  ];
  